<HiddenFromSSR>
  <footer>
    {@html "<p> Pinafore es <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore\">software de código abierto</a> creado por <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a> y distribuido bajo la <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore/blob/master/LICENSE\">Licencia AGPL</a>. Aquí está la <a href=\"/settings/about#privacy-policy\" rel=\"prefetch\">política de privacidad</a>. </p>"}
  </footer>
</HiddenFromSSR>
<script>
  import HiddenFromSSR from './HiddenFromSSR.html'

  export default {
    components: {
      HiddenFromSSR
    }
  }
</script>
